<template>
  <NotificationTemplate :notification="notification">
    <template #pic>
      <div class="label-pic is-purple">
        <icon
          data="@icon/task-icon.svg"
          class="label-pic__icon"
          :fill="true"
          width="var(--icon-24)"
          height="var(--icon-24)"
          color="#6A1B9A"
        />
      </div>
    </template>
    <template #title>
      <BaseSubHeading
        size="large"
        color="monochrome-06"
        darkColor="monochrome-03"
        weight="400"
      >
        <a
          class="button-level button-level-large notification__simple-link"
          target="_blank"
          :href="notification.content?.itemUrl ?? '#'"
        >
          Item {{ notification.itemSequenceNumber }}
        </a>
        preceding Tasks are completed. You can begin working on your Task.
      </BaseSubHeading>
    </template>
    <template #content>
      <div
        v-for="(task, key) in notification.content?.nextTaskToWork"
        :key="key"
        className="notification__update-time-left__task"
      >
        <BaseSubHeading
          size="medium"
          color="markingBlue-02"
          darkColor="markingBlue-03"
          weight="500"
          className="notification__update-time-left__task__status"
        >
          In Progress
        </BaseSubHeading>
        <BaseSubHeading
          size="medium"
          color="monochrome-07"
          weight="400"
          className="notification__update-time-left__task__name"
        >
          {{ task.name }}
        </BaseSubHeading>
        <BaseSubHeading
          size="medium"
          color="monochrome-06"
          darkColor="monochrome-03"
          weight="500"
          className="notification__update-time-left__task__type"
        >
          {{ $t(`cycleTimeByTaskType.${task.type}`) }}
        </BaseSubHeading>

        <BaseSubHeading
          size="small"
          color="monochrome-07"
          weight="500"
          className="notification__update-time-left__task__estimation is-grey"
        >
          {{ task.estimatedHours ? `${task.estimatedHours} hr` : "-" }}
        </BaseSubHeading>
      </div>
    </template>
  </NotificationTemplate>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component"
import { Prop } from "vue-property-decorator"

import NotificationTemplate from "@/components/Notification/NotificationTemplate.vue"

import { NotificationItem } from "@/models/Notification/NotificationItem"

@Options({
  name: "ITEM_UPDATE_NEXT_TASK_TO_WORK",
  components: {
    NotificationTemplate
  }
})
export default class ITEM_UPDATE_NEXT_TASK_TO_WORK extends Vue {
  @Prop() readonly notification: NotificationItem
}
</script>
